<script lang="ts">
    import CN from "classnames";
    import { onMount } from "svelte";

    import Button from "./Buttons/Button.svelte";

    export let text: string;
    export let height = "5em";
    export let gap = "0.1em";
    export let gradientColor = "white";

    let className: string | undefined = undefined;
    export { className as class };

    let expanded = false;
    let isOverflowing = false;
    let maxHeight = "1000px";
    let textContainer: HTMLDivElement;

    const toggle = () => {
        expanded = !expanded;
    };

    const checkOverflow = () => {
        if (!textContainer) return;

        maxHeight = `${textContainer.scrollHeight}px`;
        isOverflowing = textContainer.scrollHeight > textContainer.clientHeight;
    };

    onMount(() => {
        let observer: ResizeObserver;

        if (textContainer) {
            observer = new ResizeObserver(() => {
                checkOverflow();
            });

            observer.observe(textContainer);
            checkOverflow();
        }

        return () => observer?.disconnect();
    });

    const onTextChange = () => {
        expanded = false;
        checkOverflow();
    };

    $: {
        text;
        onTextChange();
    }
</script>

<div class={CN("gw-view-more", className)} style="--gap: {gap};">
    <div
        bind:this={textContainer}
        class="gw-view-more__container"
        style="--height: {height}; --maxHeight: {expanded ? maxHeight : height}"
    >
        <p class="gw-view-more__text">{text}</p>

        {#if isOverflowing && !expanded}
            <div
                class="gw-view-more__gradient"
                style="--gradientColor: {gradientColor}"
            />
        {/if}
    </div>

    {#if isOverflowing || expanded}
        <Button variant="link" class="gw-view-more__button" on:click={toggle}>
            {#if expanded}
                <slot name="view_less_text" />
            {:else}
                <slot name="view_more_text" />
            {/if}
        </Button>
    {/if}
</div>

<style lang="postcss">
    .gw-view-more {
        position: relative;

        &__container {
            overflow: hidden;
            position: relative;
            transition: max-height 0.3s ease;
            max-height: var(--maxHeight);
        }

        &__text {
            margin: 0;
            padding: 0;
            line-height: 1.5;
            white-space: break-spaces;
        }

        &__gradient {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 2em;
            background: linear-gradient(
                to bottom,
                rgba(255, 255, 255, 0) 0%,
                var(--gradientColor, white) 100%
            );

            pointer-events: none;
            z-index: 1;
        }
    }

    :global(.gw-btn.gw-button.gw-view-more__button) {
        margin: var(--gap, 0.1em) 0 0;
        font-size: 1em;
        text-transform: capitalize;
    }
</style>
